import { MessageItem, MessageItemLevel, MessageItemType } from './message-center.model';

export abstract class Evaluate {
  private nextEvaluation: Evaluate = undefined;

  abstract evaluate(item: MessageItem): boolean;

  public AddEvaluation(evaluation: Evaluate): Evaluate {
    evaluation.nextEvaluation = this;
    return evaluation;
  }

  public executeEvaluation(item: MessageItem): boolean {
    let result = true;
    if (this.nextEvaluation != null) {
      result = this.nextEvaluation.executeEvaluation(item);
    }

    if (result) {
      result = this.evaluate(item);
    }

    return result;
  }
}

export class TypeEvaluation extends Evaluate {
  constructor(private type: MessageItemType) {
    super();
  }

  public evaluate(item: MessageItem): boolean {
    return item.type === this.type;
  }
}

export class LevelEvaluation extends Evaluate {
  constructor(private level: MessageItemLevel) {
    super();
  }

  public evaluate(item: MessageItem): boolean {
    return item.level === this.level;
  }
}

export class IdEvaluation extends Evaluate {
  constructor(private id: number) {
    super();
  }

  public evaluate(item: MessageItem): boolean {
    return item.id === this.id;
  }
}

export class CodeEvaluation extends Evaluate {
  constructor(private code: string) {
    super();
  }
  public evaluate(item: MessageItem): boolean {
    return item.code === this.code;
  }
}

export class EmptyEvaluation extends Evaluate {
  public evaluate(_item: MessageItem): boolean {
    return true;
  }
}
